module.exports = __webpack_public_path__ + "static/media/Map.6f0b4060.jpg";